import React, { useState } from 'react'
import {
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableHeader,
    TableRow,
} from "@/components/ui/table"
import { AddedItemsSchema } from '../-data/schema'
import { convertToCurrencyRounded } from '@/utils/currency_converter';
import { Button } from '@/components/ui/button';
import { Pen, Trash } from 'lucide-react';
import dayjs from 'dayjs';
import customParseFormat from "dayjs/plugin/customParseFormat";
dayjs.extend(customParseFormat);

const TableList = ({ items, setEditItem, deleteItem, supplierState, isSupplierSez }: {
    items: AddedItemsSchema[];
    setEditItem: (item: AddedItemsSchema) => void
    deleteItem: (item: AddedItemsSchema) => void
    supplierState?: string
    isSupplierSez?: boolean
}) => {

    return (
        <div className='overflow-auto h-full'>
            <Table>
                <TableHeader>
                    <TableRow>
                        <TableHead>SL No.</TableHead>
                        <TableHead>Product Name</TableHead>
                        <TableHead>Batch Number</TableHead>
                        <TableHead>Expiry Date</TableHead>
                        <TableHead>Production Date</TableHead>
                        <TableHead>Original Quantity</TableHead>
                        <TableHead>Bonus Quantity</TableHead>
                        <TableHead>Cost</TableHead>
                        <TableHead>Price</TableHead>
                        <TableHead>Tax</TableHead>
                        <TableHead>Net Total</TableHead>
                        <TableHead>Total with Tax</TableHead>
                        <TableHead></TableHead>
                        <TableHead></TableHead>
                    </TableRow>
                </TableHeader>
                <TableBody>
                    {
                        items.length > 0 
                            && items.map((item, index) => (
                                <TableRow key={index}>
                                    <TableCell>{index+1}</TableCell>
                                    <TableCell>{item.trade_name}</TableCell>
                                    <TableCell>{item.batch_number}</TableCell>
                                    <TableCell>{item.expiry_date ? dayjs(item.expiry_date).format("DD/MM/YYYY") : "N/A"}</TableCell>
                                    <TableCell>{item.production_date ? dayjs(item.production_date).format("DD/MM/YYYY") : "N/A"}</TableCell>
                                    <TableCell>{item.quantity.original}</TableCell>
                                    <TableCell>{item.quantity.bonus}</TableCell>
                                    <TableCell>{convertToCurrencyRounded(item.cost)}</TableCell>
                                    <TableCell>{convertToCurrencyRounded(item.price!)}</TableCell>
                                    <TableCell>{item.taxProfile.applicableTaxes.filter(item => {
                                        const countryCode = localStorage.getItem('pharmacyMetadata') ? JSON.parse(localStorage.getItem('pharmacyMetadata') || '{}').countryCode : 'IN';
                                        if (countryCode === 'IN') {
                                            if (isSupplierSez) {
                                                // For SEZ Suppliers, we have to charge only the CGST and SGST
                                                return item.componentCode === 'CGST' || item.componentCode === 'SGST';
                                            } else {
                                                const pharmacyState = localStorage.getItem('pharmacyLocationDetails') ? JSON.parse(localStorage.getItem('pharmacyLocationDetails') || '{}').state : '';
                                                // For non-SEZ Suppliers, we charge IGST if the supplier state is different from the pharmacy state
                                                if (item.componentCode === 'IGST' && supplierState !== pharmacyState) {
                                                    return true;
                                                }
                                                // For same state suppliers, we charge CGST and SGST
                                                return (item.componentCode === 'CGST' || item.componentCode === 'SGST') && supplierState === pharmacyState;
                                            }
                                        } else if (countryCode === 'AE') {
                                            return item.componentCode.includes('VAT');
                                        }
                                        return false;
                                    }).map(a => {
                                        return `${a.componentCode} (${a.ratePercent}%) `;
                                    })}</TableCell>
                                    <TableCell>{convertToCurrencyRounded(item.quantity.original * item.cost)}</TableCell>
                                    <TableCell>
                                        {
                                            convertToCurrencyRounded(
                                                item.quantity.original * item.cost + 
                                                (
                                                    item.taxProfile.applicableTaxes.filter(item => {
                                                        const countryCode = localStorage.getItem('pharmacyMetadata') ? JSON.parse(localStorage.getItem('pharmacyMetadata') || '{}').countryCode : 'IN';
                                                        if (countryCode === 'IN') {
                                                            if (isSupplierSez) {
                                                                // For SEZ Suppliers, we have to charge only the CGST and SGST
                                                                return item.componentCode === 'CGST' || item.componentCode === 'SGST';
                                                            } else {
                                                                const pharmacyState = localStorage.getItem('pharmacyLocationDetails') ? JSON.parse(localStorage.getItem('pharmacyLocationDetails') || '{}').state : '';
                                                                // For non-SEZ Suppliers, we charge IGST if the supplier state is different from the pharmacy state
                                                                if (item.componentCode === 'IGST' && supplierState !== pharmacyState) {
                                                                    return true;
                                                                }
                                                                // For same state suppliers, we charge CGST and SGST
                                                                return item.componentCode === 'CGST' || item.componentCode === 'SGST';
                                                            }
                                                        } else if (countryCode === 'AE') {
                                                            return item.componentCode.includes('VAT');
                                                        }
                                                        return false;
                                                    }).reduce((acc, tax) => {
                                                        const countryCode = localStorage.getItem('pharmacyMetadata') ? JSON.parse(localStorage.getItem('pharmacyMetadata') || '{}').countryCode : 'IN';
                                                        if (countryCode === 'IN') {
                                                            if (isSupplierSez) {
                                                                // For SEZ Suppliers, we have to charge only the CGST and SGST
                                                                if (tax.componentCode === 'CGST' || tax.componentCode === 'SGST') {
                                                                    return acc + (tax.ratePercent / 100) * item.cost;
                                                                }
                                                            } else {
                                                                const pharmacyState = localStorage.getItem('pharmacyLocationDetails') ? JSON.parse(localStorage.getItem('pharmacyLocationDetails') || '{}').state : '';
                                                                // For non-SEZ Suppliers, we charge IGST if the supplier state is different from the pharmacy state
                                                                if (tax.componentCode === 'IGST' && supplierState !== pharmacyState) {
                                                                    return acc + (tax.ratePercent / 100) * item.cost;
                                                                }
                                                                // For same state suppliers, we charge CGST and SGST
                                                                if ((tax.componentCode === 'CGST' || tax.componentCode === 'SGST') && supplierState === pharmacyState) {
                                                                    return acc + (tax.ratePercent / 100) * item.cost;
                                                                }
                                                            }
                                                        } else if (countryCode === 'AE') {
                                                            return acc + (tax.ratePercent / 100) * item.cost;
                                                        }
                                                        return acc;
                                                    }, 0) * item.quantity.original
                                                )
                                            )
                                        }
                                    </TableCell>
                                    <TableCell>
                                        <Button variant={'outline'} onClick={() => {
                                        deleteItem(item)
                                    }}>
                                        <Trash className='w-4 h-4' />
                                    </Button>
                                </TableCell>
                                <TableCell>
                                    <Button variant={'outline'} onClick={() => setEditItem(item)}>
                                        <Pen className='w-4 h-4' />
                                        </Button>
                                    </TableCell>
                                </TableRow>
                            ))                        
                    }
                </TableBody>
            </Table>

            {
                items.length === 0 
                    && (
                        <div className='grid place-items-center h-[90%]'>
                            <div className='flex flex-col justify-center'>
                                <p className='text-2xl'>Start by adding products</p>
                                <img 
                                    src='/arrow.png' 
                                    alt='empty' 
                                    width={300}
                                    className='ml-10'
                                />
                            </div>
                        </div>
                    )
            }
        </div>
    )
}

export default TableList